import React, { useState, useEffect } from "react";
import $ from "jquery";
import I18n from 'i18n.js.erb';
import {setLocaleInDataPiker} from "../../utils/utils";
import DatePicker from "react-datepicker";

const VacationModeModal = ({user}) => {

    const [onVacation, setOnVacation] = useState(user.on_vacation)
    const [vacationEndDate, setVacationEndDate] = useState(null)
    const [showVacationModeDetails, setShowVacationModeDetails] = useState(false)
    const [selectedTurnOffMode, setSelectedTurnOffMode] = useState(null)

    function handleChangeVacationMode(e) {
        if (e.target.className.includes('fa-umbrella-beach') && user.on_vacation) {
            setOnVacation(false);
            setShowVacationModeDetails(false);
            $('#' + e.target.id).removeClass('fa-umbrella-beach');
            $('#' + e.target.id).addClass('fa-briefcase');
        } else if (e.target.className.includes('fa-briefcase') && !user.on_vacation) {
            setOnVacation(true);
            setShowVacationModeDetails(true);
            $('#' + e.target.id).removeClass('fa-briefcase');
            $('#' + e.target.id).addClass('fa-umbrella-beach');
        }
    }

    function handleChangeVacationModeDetail(e) {
        if (e.target.id === 'vacation_mode_automatic') {
            setSelectedTurnOffMode('automatic');
            setVacationEndDate(null);
        } else {
            setSelectedTurnOffMode('manual');
        }
    }

    function handleSaveChanges() {
        user.on_vacation = onVacation;
        if (onVacation && vacationEndDate) {
            // trick orribile per fare in modo che il database scriva sempre il giorno corrente,
            // senza effettuare trasformazioni in base al GMT
            vacationEndDate.setHours(8);
            user.vacation_end_date = vacationEndDate;
        } else {
            user.vacation_end_date = null;
        }

        const url = "/users/" + user.id;
        fetch(url + '.json', {
            method: 'PATCH',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({user: user}),
        }).then(response => {
            if (!response.ok) {
                throw Error("An error occour during saving data on the database");
            } else {
                return response.json();
            }
        }).then(data => {
            location.reload();
        });
    }

    $('#vacationModeModal').on('hidden.bs.modal', function (e) {
        setOnVacation(user.on_vacation);
        setVacationEndDate(null);
        setShowVacationModeDetails(false);
        setSelectedTurnOffMode(false);
    });

    return (
      <div>
          <div className="modal" id="vacationModeModal" tabIndex="-1" role="dialog" aria-labelledby="vacationModeModalLabel" aria-hidden="true">
              <div className="modal-dialog" role="document">
                  <div className="modal-content">
                      <div className="modal-header">
                          <h5 className="modal-title" id="vacationModeModalLabel">{I18n.t('js.profilePage.vacationMode')}</h5>
                          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                          </button>
                      </div>
                      <div className="modal-body">
                          {
                              user.on_vacation ? I18n.t('js.profilePage.goOffVacationMode') : I18n.t('js.profilePage.goOnVacationMode')
                          }

                          <div className="d-flex flex-column align-items-center py-2">
                              {
                                  onVacation ?
                                        <i className="fas fa-umbrella-beach fa-5x cursor-pointer my-3" id="vacation_mode_toggle" onClick={handleChangeVacationMode}></i>
                                    :
                                        <i className="fas fa-briefcase fa-5x cursor-pointer my-3" id="vacation_mode_toggle" onClick={handleChangeVacationMode}></i>
                              }
                              {
                                  user.on_vacation ? <div>{I18n.t('js.profilePage.currentlyOnVacation')}</div> : <div>{I18n.t('js.profilePage.currentlyOffVacation')}</div>
                              }
                          </div>

                            <div id="vacation_mode_details" className={showVacationModeDetails ? '' : 'd-none'}>
                                <div className="my-4"></div>
                                <label>{I18n.t('js.profilePage.howLongVacation')}</label><br/>

                                {
                                    ['manual', 'automatic'].map((type) => {
                                        return <div key={type} className="d-flex">
                                            <input type="radio"
                                                   value={type}
                                                   id={"vacation_mode_" + type}
                                                   checked={selectedTurnOffMode === type}
                                                   onChange={handleChangeVacationModeDetail}/>
                                                <label className="pr-3 ml-1" htmlFor={"vacation_mode_" + type}>{
                                                    type === 'automatic' ? <React.Fragment>{I18n.t('js.profilePage.automaticTurnOffVacation')}<div className='d-flex w-50'><DatePicker
                                                  locale={setLocaleInDataPiker()}
                                                  className="form-control"
                                                  selected={vacationEndDate}
                                                  name="vacation_end_date"
                                                  id="vacation_end_date"
                                                  onChange={date => {
                                                      setVacationEndDate(date);
                                                  }}
                                                  withPortal
                                                /></div></React.Fragment>
                                                      : I18n.t('js.profilePage.manualTurnOffVacation')
                                                }
                                                </label>
                                            </div>
                                    })
                                }
                            </div>

                      </div>
                      <div className="modal-footer">
                          <button type="button"
                                  className="btn-standard-outline br-20px pr-2 pl-2 w-120px btn-standard-outline-resized"
                                  data-dismiss="modal">
                              {I18n.t('js.common.button.cancel')}
                          </button>
                          <button type="button"
                                  className="btn-standard bg-aig-gradient text-light br-20px pr-2 pl-2 w-120px btn-standard-resized pt-4px-imp h-35px"
                                  onClick={handleSaveChanges}>
                              {I18n.t('js.common.button.save')}
                          </button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    );
}

export default VacationModeModal;
